// extracted by mini-css-extract-plugin
export default {"your_rd":"bx","title":"cx","subtitle":"ex","rd_bio_wrapper":"fx","rd_text_mobile":"gx","rd_bio":"hx","img":"ix","rd_info":"jx","rd_name":"kx","rd_stat":"lx","rd_text":"mx","btn_mobile":"nx"};
    if(module.hot) {
      // 1714422955984
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  